import { ClassValue } from 'clsx';
import { bounceIn } from '@shared/styles';
import { Button } from './Button';
import { ButtonProps } from './ButtonProps';
import styles from './ClearButton.module.css';

interface ClearButtonProps {
  onClick: VoidFunction;
  className?: ClassValue;
  size?: ButtonProps['size'];
  icon?: ButtonProps['icon'];
  iconSize?: ButtonProps['iconSize'];
  hasError?: boolean;
}

export function ClearButton({
  className,
  onClick,
  size = 'small',
  icon = 'exit',
  iconSize,
  hasError,
}: ClearButtonProps) {
  return (
    <Button
      className={[styles.clearButton, bounceIn, className, hasError && styles.hasError]}
      onClick={onClick}
      variant="tertiary"
      icon={icon}
      iconSize={iconSize}
      iconOnly
      size={size}
    />
  );
}
